import React, { useEffect, useState } from 'react';
import { CinematicHeader } from './components/CinematicHeader';
import { ServiceFooter } from './components/ServiceFooter';
import { GlobalFooter } from './components/GlobalFooter';
// Pages
import { Home } from './pages/Home';
import { Experience } from './pages/Experience';
import { Menu } from './pages/Menu';
import { Events } from './pages/Events';
import { Gallery } from './pages/Gallery';
import { DressCode } from './pages/DressCode';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  useEffect(() => {
    // Intersection Observer for scroll animations
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.15
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);
    // Re-run observer when page changes
    const elements = document.querySelectorAll('.fade-section');
    elements.forEach(el => observer.observe(el));
    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, [currentPage]);
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <Home onNavigate={setCurrentPage} data-id="element-0" />;
      case 'experience':
        return <Experience data-id="element-1" />;
      case 'menu':
        return <Menu data-id="element-2" />;
      case 'events':
        return <Events onNavigate={setCurrentPage} data-id="element-3" />;
      case 'gallery':
        return <Gallery data-id="element-4" />;
      case 'dresscode':
        return <DressCode data-id="element-5" />;
      default:
        return <Home onNavigate={setCurrentPage} data-id="element-6" />;
    }
  };
  return <div className="min-h-screen bg-matte text-white font-sans selection:bg-gold/30 selection:text-white" data-id="element-7">
      <CinematicHeader onNavigate={setCurrentPage} currentPage={currentPage} data-id="element-8" />

      {renderPage()}

      <ServiceFooter data-id="element-9" />
      <GlobalFooter onNavigate={setCurrentPage} data-id="element-10" />
    </div>;
}